/**
 * Copyright (C) 2019 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiBase from '@here/lui-base'
import scopedCss from 'lui-modalnotification.scss'
import template from 'lui-modalnotification.html'

export default class LuiModalnotification extends LuiBase {
  static get is() {
    return 'lui-modal-notification'
  }

  static get css() {
    return scopedCss
  }

  static get template() {
    return template
  }

  openChanged(oldValue, newValue) {
    if (newValue !== null) {
      this.overlay.show()
    } else {
      this.overlay.close()
    }
  }

  impactChanged(oldValue, newValue) {
    const notification = this.shadowRoot.querySelector('lui-notification')
    if (newValue !== null) {
      notification.setAttribute('impact', newValue)
      this.classList.add(`lui-${newValue}`)
    } else {
      notification.removeAttribute('impact')
      this.classList.remove(`lui-${newValue}`)
    }
  }

  get overlay() {
    this._overlay = this._overlay || this.shadowRoot.querySelector('lui-overlay')
    return this._overlay
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-modalnotification/lui-modalnotification.js
// module id = 276
// module chunks = 0 1 30